export enum ChartState {
    LOADING = "LOADING",
    NODATA = "NODATA",
    SUCCESS = "SUCCESS",
}
